module.exports = __webpack_public_path__ + "img/Dorothe_Engelbretsdotter_Taare-Offer.a924007d.jpg";